export default __webpack_public_path__ + "static/media/scarlet.ad2411bf.mp4";